export default class ResourceEntity {
    static getEntityData(elem: any) {
        return {
            uuid: elem.querySelector("#resource_uuid") ? (elem.querySelector("#resource_uuid") as HTMLInputElement).value : null,
            name: (elem.querySelector("#resource_name") as HTMLInputElement).value,
        }
    }
}